import { useLeaves, useMe } from '../../leaves';

export const useMyLeaves = () => {
  const meQuery = useMe();
  const me = meQuery.data;
  const crewId = me?.crew.id;

  // Wait for `me` before fetching — otherwise the query fires with an
  // undefined crewId and returns every crew's leaves.
  const leavesQuery = useLeaves({ crewId }, { enabled: !!crewId });

  return {
    me,
    leaves: leavesQuery.data,
    isLoading: meQuery.isLoading || leavesQuery.isLoading,
    isError: meQuery.isError || leavesQuery.isError,
  };
};
